export default __webpack_public_path__ + "static/2014-asa-testing-at-a780cff6d09522ba97bc3c045bdfa909.pdf";